import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OAuthEvent, OAuthService } from 'angular-oauth2-oidc';
import { filter, Subscription } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { MatAnchor, MatButtonModule } from "@angular/material/button";

@Component({
  selector: 'login',
  templateUrl: './login.html',
  styleUrl: './login.sass',
  imports: [MatAnchor, MatButtonModule],
})
export class Login implements OnInit{
  app = inject(AppService);
  private oauth = inject(OAuthService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private sub = new Subscription();
  constructor() {}
  
  async ngOnInit() {
    await this.oauth.loadDiscoveryDocument();

    const qp = new URLSearchParams(window.location.search);
    const isCallback = qp.has('code') || qp.has('session_state');
    // vom Guard angehängtes Ziel, z.B. wenn ein Deep Link in einem neuen Tab geöffnet wird
    const redirect = safePath(qp.get('redirect'));

    if (isCallback) {
      await this.oauth.tryLoginCodeFlow();
    } else if (!this.oauth.hasValidAccessToken()) {
      // als OIDC state mitgeben, damit das Ziel den Redirect zum IdP überlebt
      this.oauth.initLoginFlow(redirect ?? '/tickets');
      return;
    }

    if (this.oauth.hasValidAccessToken()) {
      await this.finishNavigation(redirect);
      return;
    }

    this.sub.add(
      this.oauth.events
        .pipe(filter((e: OAuthEvent) => e.type === 'token_received'))
        .subscribe(() => this.finishNavigation(redirect))
    );
  }

  async finishNavigation(redirect: string | null = null) {
    // Rücksprungziel: ?redirect vom Guard, sonst OIDC state (vom Guard gesetzt) oder /tickets
    const stateTarget = safePath(safeDecode(this.oauth.state ?? ''));
    const target = redirect ?? stateTarget ?? '/tickets';
    await this.router.navigateByUrl(target, { replaceUrl: true });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  
  logout() {
    this.oauth.logOut();
  }
  
}

function safeDecode(v: string) {
  try { return decodeURIComponent(v); } catch { return v; }
}

/** Nur app-interne Pfade als Rücksprungziel zulassen, keine (protokoll-relativen) fremden URLs. */
function safePath(v: string | null | undefined): string | null {
  if (!v || !v.startsWith('/') || v.startsWith('//')) return null;
  return v;
}

